import API from '../api/api'
import {_exportDownloadLinkDecorator, parseItemId} from '../helper'

const SYNC_STATIC_THEME_PENDING = 'SYNC_STATIC_THEME_PENDING'
const SYNC_STATIC_THEME_PROGRESS = 'SYNC_STATIC_THEME_PROGRESS'
const SYNC_STATIC_THEME_RESPONSE = 'SYNC_STATIC_THEME_RESPONSE'

const SYNC_STATIC_THEME_ASSET_PENDING = 'SYNC_STATIC_THEME_ASSET_PENDING'
const SYNC_STATIC_THEME_ASSET_PROGRESS = 'SYNC_STATIC_THEME_ASSET_PROGRESS'
const SYNC_STATIC_THEME_ASSET_RESPONSE = 'SYNC_STATIC_THEME_ASSET_RESPONSE'
const SYNC_STATIC_THEME_ASSET_ABORTED = 'SYNC_STATIC_THEME_ASSET_ABORTED'

const SAVE_STATIC_THEME_PENDING = 'SAVE_STATIC_THEME_PENDING'
const SAVE_STATIC_THEME_PROGRESS = 'SAVE_STATIC_THEME_PROGRESS'
const SAVE_STATIC_THEME_RESPONSE = 'SAVE_STATIC_THEME_RESPONSE'
const SAVE_STATIC_THEME_ABORTED = 'SAVE_STATIC_THEME_ABORTED'

const EXPORT_STATIC_THEME_PENDING = 'EXPORT_STATIC_THEME_PENDING'
const EXPORT_STATIC_THEME_PROGRESS = 'EXPORT_STATIC_THEME_PROGRESS'
const EXPORT_STATIC_THEME_RESPONSE = 'EXPORT_STATIC_THEME_RESPONSE'

const IMPORT_STATIC_THEME_PENDING = 'IMPORT_STATIC_THEME_PENDING'
const IMPORT_STATIC_THEME_PROGRESS = 'IMPORT_STATIC_THEME_PROGRESS'
const IMPORT_STATIC_THEME_RESPONSE = 'IMPORT_STATIC_THEME_RESPONSE'

const RESET_ERRORS = 'RESET_ERRORS'
const CLEAR_EXPORT_URLS = 'CLEAR_EXPORT_URLS'

const initialState = {
  sync_static_theme_pending: true,
  save_static_theme_pending: false,
  sync_static_theme_asset_pending: false,
  export_static_theme_pending: false,
  export_po_download_url: null,
  export_csv_download_url: null,
  import_static_theme_pending: false,
  imported_entries: 0,
  assets: [],
  progress: 0,
  error: false,
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }

    case SYNC_STATIC_THEME_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_static_theme_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case SYNC_STATIC_THEME_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_STATIC_THEME_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          sync_static_theme_pending: false,
          assets: action.response.assets.slice()
        }
      } else {
        return {
          ...state,
          static_static_theme_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }

    case SYNC_STATIC_THEME_ASSET_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_static_theme_asset_pending: true,
        error: false,
      }
    }
    case SYNC_STATIC_THEME_ASSET_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_STATIC_THEME_ASSET_ABORTED: {
      return {
        ...state,
        sync_static_theme_asset_pending: false,
        error: false,
      }
    }
    case SYNC_STATIC_THEME_ASSET_RESPONSE: {
      if(action.response.success === true) {
        let newAssets = state.assets.slice()
        let assetToUpdate = newAssets.find(x => x.id == action.response.asset_id)
        
        assetToUpdate.synchronized = true
        assetToUpdate.progress = action.response.progress
        assetToUpdate.out_of_sync = action.response.out_of_sync
        assetToUpdate.strings = action.response.strings.slice()
        
        return {
          ...state,
          assets: newAssets,
          sync_static_theme_asset_pending: false
        }
      } else {
        return {
          ...state,
          sync_static_theme_asset_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 1,
          },
        }
      }
    }

    case SAVE_STATIC_THEME_PENDING: {
      return {
        ...state,
        progress: 0,
        save_static_theme_pending: true,
        error: false,
      }
    }
    case SAVE_STATIC_THEME_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    // a save dropped by a switch never answers, and nothing refires it - clear its flag here
    case SAVE_STATIC_THEME_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_static_theme_pending: false,
        error: false,
      }
    }
    case SAVE_STATIC_THEME_RESPONSE: {
      let isOk = true
      let newAssets = state.assets.slice();
      let error = false;
      let saveInfos = [];

      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false
        } else {
          if(response.type == 'prepared') {
            const assetToUpdate = newAssets.find(x => x.id == response.asset_id)
            if(assetToUpdate) {
              assetToUpdate.progress = response.progress
            }

            console.log(response);
            error = false;
            saveInfos.push({
              object: parseItemId(response.asset_id),
              info: {
                ...response
              }
              //errors: newErrors
            });

          } else if(action.stale !== true) {
            // If the theme/language was switched while this save was still in flight,
            // its response no longer matches what's currently displayed - applying it
            // here would merge the previous language's text into the now-selected
            // language's strings (string ids are stable across languages).
            Object.keys(response.assets).forEach(key => {
              const assetToUpdate = newAssets.find(x => x.id == key)
              if(assetToUpdate) {

                console.log(response, response.assets[key]);

                response.assets[key].forEach(string => {
                    const stringToUpdate = assetToUpdate.strings.find(x => x.id == string.id)
                    if(stringToUpdate) {
                      stringToUpdate.source = string.source
                      stringToUpdate.target = string.target
                    }
                })
              }
            })
          }
        }
      })

      console.log(saveInfos);

      return {
        ...state,
        assets: newAssets,
        save_static_theme_pending: false,

        error: error,
        saveInfos: saveInfos,
      }
    }
    case EXPORT_STATIC_THEME_PENDING: {
      return {
        ...state,
        progress: 0,
        export_static_theme_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case EXPORT_STATIC_THEME_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case EXPORT_STATIC_THEME_RESPONSE: {
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          export_static_theme_pending: false,
          export_po_download_url: _exportDownloadLinkDecorator(action.response.po_download_url, action.options),
          export_csv_download_url: _exportDownloadLinkDecorator(action.response.csv_download_url, action.options),

        }
      } else {
        return {
          ...state,
          progress: 100,
          export_static_theme_pending: false,
          error: {
            message: action.response,
            action: action.action,
          },
        }
      }
    }

    case IMPORT_STATIC_THEME_PENDING: {
      return {
        ...state,
        progress: 0,
        import_static_theme_pending: true,
        import_cancelled: false,
        imported_entries: 0,
        error: false,
      }
    }
    case IMPORT_STATIC_THEME_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case IMPORT_STATIC_THEME_RESPONSE: {
      // the merchant cancelled after reviewing the file, nothing was imported
      if(action.response && action.response.cancelled === true) {
        return {
          ...state,
          progress: 0,
          import_static_theme_pending: false,
          import_cancelled: true
        }
      }
      let isOk = true;
      let importedEntries = 0;
      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false
        } else {
          importedEntries += response.imported_entries
        }
      })

      if(isOk == true) {
        return {
          ...state,
          progress: 100,
          import_static_theme_pending: false,
          imported_entries: importedEntries
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_static_theme_pending: false,
          imported_entries: importedEntries,
          error: {
            message: action.response.filter(response => response.success !== true),
            action: action.action,
          },
        }
      }
    }
    case CLEAR_EXPORT_URLS: {
      return {
        ...state,
        progress: 0,
        export_static_theme_pending: false,
        export_csv_download_url: null,
        export_po_download_url: null,
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}

export const syncStaticTheme = (themeId, languageId, progress) => { 
  return dispatch => {
    dispatch({
      type: SYNC_STATIC_THEME_PENDING
    })

    API.syncStaticTheme(
      themeId,
      languageId,
      progress => {
        dispatch({
          type: SYNC_STATIC_THEME_PROGRESS,
          progress: progress
        })
      },
      response => {
        // dropped by a switch, which has already refired the sync that owns the pending flag
        if(response && response.aborted === true) {
          return
        }

        dispatch({
          type: SYNC_STATIC_THEME_RESPONSE,
          response: response,
          action: () => syncStaticTheme(themeId, languageId, progress),
        })
      }
    )
  }
}

export const syncStaticThemeAsset = (themeId, assetId, languageId, progress, callback) => { 
  return dispatch => {
    dispatch({
      type: SYNC_STATIC_THEME_ASSET_PENDING
    })

    API.syncStaticThemeAsset(
      themeId,
      assetId,
      languageId,
      progress => {
        dispatch({
          type: SYNC_STATIC_THEME_ASSET_PROGRESS,
          progress: progress
        })
      },
      response => {
        // nothing refires a row sync after a switch, so the drop clears its own flag; the
        // callback builds ui from response fields the sentinel does not carry, so it is skipped
        if(response && response.aborted === true) {
          dispatch({
            type: SYNC_STATIC_THEME_ASSET_ABORTED
          });
          return;
        }

        dispatch({
          type: SYNC_STATIC_THEME_ASSET_RESPONSE,
          response: response,
          action: () => syncStaticThemeAsset(themeId, assetId, languageId, progress, callback)
        });

        if(callback) {
          callback(response);
        }
      },
      false
    )
  }
}

export const saveStaticTheme = (themeId, languageId, items, progress) => {
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_STATIC_THEME_PENDING
    })

    API.saveStaticTheme(
      themeId,
      languageId,
      items,
      progress => {
        dispatch({
          type: SAVE_STATIC_THEME_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_STATIC_THEME_ABORTED
          })
          return
        }

        const currentState = getState()
        const stale = currentState.shop.shop.edit_language !== languageId
          || currentState.themes.edit_theme !== themeId

        dispatch({
          type: SAVE_STATIC_THEME_RESPONSE,
          response: response,
          items: items,
          stale: stale,
          action: () => saveStaticTheme(themeId, languageId, items, progress)
        })
      },
      false
    )
  }
}

export const exportStaticTheme = (theme, language, options) => {
  return dispatch => {
    dispatch({
      type: EXPORT_STATIC_THEME_PENDING
    })

    API.exportStaticTheme(
      theme,
      options,
      language,
      progress => {
        dispatch({
          type: EXPORT_STATIC_THEME_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_STATIC_THEME_RESPONSE,
          response: response,
          options: options,
          action: () => exportStaticTheme(theme, language, options)
        }
      )
    })
  }
}

export const importStaticTheme = (file, fileType, theme, language) => {
  return dispatch => {
    dispatch({
      type: IMPORT_STATIC_THEME_PENDING
    })

    API.importStaticTheme(
      file,
      fileType,
      theme,
      language,
      progress => {
        dispatch({
          type: IMPORT_STATIC_THEME_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_STATIC_THEME_RESPONSE,
          response: response,
          action: () => importStaticTheme(file, fileType, theme, language)
        }
      )
    })
  }
}

export const clearExportUrls = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_EXPORT_URLS
    });
  }
}